module.exports = __webpack_public_path__ + "img/calendar.4f4f6552.png";